import React from "react"
import PropTypes from "prop-types"
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap"
import { useTranslation } from "react-i18next"

/*
 * Ajuda das exportações CSV do Movimento de vendas (IW-349), para quem usa a tela e não
 * para quem mantém o sistema: o que cada arquivo traz, quais vendas entram, como os
 * valores são formados e como o arquivo vem formatado. As regras descritas aqui são as de
 * vendasComItens.js / vendasComItensCsv.js no backend — mudou lá, muda o texto.
 */
const MovimentoVendasAjudaCsv = ({ isOpen, toggle }) => {
  const { t } = useTranslation()
  const secoes = t("movimentovendas.ajudacsv.secoes", { returnObjects: true })

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg" scrollable centered>
      <ModalHeader toggle={toggle}>{t("movimentovendas.ajudacsv.titulo")}</ModalHeader>
      <ModalBody>
        <p className="text-muted">{t("movimentovendas.ajudacsv.introducao")}</p>
        {(Array.isArray(secoes) ? secoes : []).map(secao =>
          <section key={secao.titulo} className="mb-3">
            <h5 className="font-size-15">{secao.titulo}</h5>
            <ul className="mb-0 ps-3">
              {secao.itens.map(item => <li key={item} className="mb-1">{item}</li>)}
            </ul>
          </section>)}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>{t("movimentovendas.ajudacsv.fechar")}</Button>
      </ModalFooter>
    </Modal>
  )
}

MovimentoVendasAjudaCsv.propTypes = {
  isOpen: PropTypes.bool,
  toggle: PropTypes.func
}

export default MovimentoVendasAjudaCsv
